var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58541 9.14844H0L5.12563 17.5284C5.50027 18.1394 6.07924 18.5584 6.74336 18.7156L8.906 14.8398L5.58541 9.14844Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 18,
    width: 6,
    height: 1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34979 18.785H11.0791L6.99219 18.7676C7.11139 18.785 7.23059 18.785 7.34979 18.785Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0947 18.7676H7.00781V18.785H11.0947V18.7676Z",
    fill: "url(#paint0_linear_12847_52337)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 18,
    width: 2,
    height: 1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 18.7677H7.01605C6.93091 18.7502 6.84576 18.7328 6.76062 18.7153L6.72656 18.7677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01605 18.7153H6.72656V18.7677H7.01605V18.7153Z",
    fill: "url(#paint1_linear_12847_52337)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 6,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 18.7141C6.81171 18.7316 6.89685 18.749 6.98199 18.7665L11.0689 18.7839L8.88921 14.8384L6.72656 18.7141Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0689 14.8384H6.72656V18.7839H11.0689V14.8384Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 18.7141C6.81171 18.7316 6.89685 18.749 6.98199 18.7665L11.0689 18.7839L8.88921 14.8384L6.72656 18.7141Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0689 14.8384H6.72656V18.7839H11.0689V14.8384Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 14,
    width: 4,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0951 18.7839L8.89844 14.8384L11.0951 18.7839Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0951 14.8384H8.89844V18.7839H11.0951V14.8384Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12847_52337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 16,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 0C18.2131 0 17.515 0.453914 17.0892 1.30937L10.8738 11.5748L8.89844 14.8395H14.4328L23.9007 0H19.2008Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12847_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9007 0H8.89844V14.8395H23.9007V0Z",
    fill: "url(#paint2_linear_12847_52337)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12847_52337",
    x1: 7.00119,
    y1: 18.7717,
    x2: 11.0871,
    y2: 18.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12847_52337",
    x1: 6.72267,
    y1: 18.7389,
    x2: 7.01083,
    y2: 18.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12847_52337",
    x1: 8.89264,
    y1: 7.41341,
    x2: 23.8914,
    y2: 7.41341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818011,
    stopColor: "#6ABD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1853,
    stopColor: "#8DC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A7CE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#BBD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#C9D92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7265,
    stopColor: "#D1DC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DD28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/Green Check.5e92fe48749ef02283db20f119214d26.svg";
export { ForwardRef as ReactComponent };